<button type="button" class="btn" title="Filter Equipment" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
    <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
</button>

<div bsModal #equipmentFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <form (ngSubmit)="applyFilter()">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Equipment</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Serial Number</label>
                                </div>
                                <input name="FilterSerial" type="text" class="form-control" placeholder="Serial Number" [(ngModel)]="serial" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Model</label>
                                </div>
                                <select name="selectedModels" class="form-control" size="10" multiple="multiple" [(ngModel)]="selectedModels">
                                    <option *ngFor="let model of models" [value]="model.Id">{{ model.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Classification</label>
                                </div>
                                <select name="selectedClassifications" class="form-control" size="10" multiple="multiple" [(ngModel)]="selectedClassifications">
                                    <option *ngFor="let classification of classifications" [value]="classification.Id">{{ classification.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Powered By</label>
                                </div>
                                <select name="selectedPowereBys" class="form-control" size="10" multiple="multiple" [(ngModel)]="selectedPoweredBys">
                                    <option *ngFor="let poweredBy of poweredBys" [value]="poweredBy.Id">{{ poweredBy.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Status</label>
                                </div>
                                <div class="btn-group btn-group-justified">
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="activeEquipment" [class.btn-warning]="!activeEquipment" (click)="activeEquipment = !activeEquipment">
                                            {{ activeEquipment ? 'Hide' : 'Show' }} Active Equipment
                                        </button>
                                    </div>
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="inActiveEquipment" [class.btn-warning]="!inActiveEquipment" (click)="inActiveEquipment = !inActiveEquipment">
                                            {{ inActiveEquipment ? 'Hide' : 'Show' }} Inactive Equipment
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </div>
        </form>
    </div>
</div>